import { sumBy, round } from 'lodash';

type RealisationAllocation = {
  commitmentId: string;
  allocationPercentage: number;
  receivedConsiderationLcy: number;
  earnoutConsiderationLcy: number;
  escrowConsiderationLcy: number;
  withholdingTaxPayableLcy: number;
  withholdingTaxExempt: boolean;
  unitsAllocated: number;
};

export default function recalculateWitholdingTaxForRealisationAllocations<
  T extends RealisationAllocation,
>(
  allocations: Array<T>,
  totals: {
    totalWithholdingTaxLcy: number;
  },
): Array<T> {
  const { totalWithholdingTaxLcy } = totals;

  const nonExemptAllocations = allocations.filter(
    (allocation) => !allocation.withholdingTaxExempt,
  );

  if (nonExemptAllocations.length === 0) {
    return allocations.map((allocation) => ({
      ...allocation,
      withholdingTaxPayableLcy: 0,
    }));
  }

  if (nonExemptAllocations.length === allocations.length) {
    return allocations.map((allocation) => ({
      ...allocation,
      withholdingTaxPayableLcy: round(
        (allocation.allocationPercentage / 100) * totalWithholdingTaxLcy,
        2,
      ),
    }));
  }

  const totalNonExemptAllocationPercentage = sumBy(
    nonExemptAllocations,
    'allocationPercentage',
  );

  return allocations.map((allocation) => {
    if (allocation.withholdingTaxExempt) {
      return {
        ...allocation,
        withholdingTaxPayableLcy: 0,
      };
    }

    return {
      ...allocation,
      withholdingTaxPayableLcy: round(
        (allocation.allocationPercentage / totalNonExemptAllocationPercentage) *
          totalWithholdingTaxLcy,
        2,
      ),
    };
  }) as Array<T>;
}
